import { GoogleErrorResponse } from './google-error-response';
/**
 * Error thrown by Google API if underlying response status code is not 2xx.
 */
export class GoogleApiError extends Error {
    /**
     * Constructor.
     * @param statusCode Original status code taken from http response.
     * @param errorResponse Error description parsed from body.
     */
    constructor(
        public readonly statusCode: number,
        public readonly errorResponse?: GoogleErrorResponse
    ) {
        super(
            errorResponse?.error?.message ??
                `Google API error occurred with status code ${statusCode} and unknown message.`
        );
    }
}
